module.exports = __webpack_public_path__ + "media/images/design/images/bn_chiiki-93c3ddbfca0d0633190d4af0ec6b33fd.jpg";